// SECTIONS

import {
    constables
} from './base.js';

const breakpoint = constables().breakpoint;

const times = constables().times;
const timem = constables().timem;
const timel = constables().timel;

// INIT

export function initgallery() {

    let gallery = document.querySelectorAll('figure.gallery')
    if (gallery.length !== 0) {
        routes(gallery);
    }

}

function routes(gallery) {

    gallery.forEach(image => {

        image.addEventListener('click', () => {

            build(image);

        });

    })

}

function build(image){

    let figure = image.cloneNode(true);
    figure.removeAttribute('style');
    figure.classList.add('gallery-aktiv');

    let color = figure.getAttribute('color');
    let img = figure.querySelector('img');
    img.style.backgroundColor = color;
    
    document.body.appendChild(figure);

    figure.addEventListener('click', () => {

        destroy(figure);

    });

}

function destroy(figure){

    figure.remove();

}